
(() => {
  const parseJSON = (node) => {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  };

  const syncSelectMetadata = (select) => {
    if (!select) return;
    Array.from(select.options).forEach((option) => {
      if (option.value === select.value) option.setAttribute('selected','selected');
      else option.removeAttribute('selected');
    });
  };

  const reconcileProduct = (info, {respectUrl=true} = {}) => {
    if (!info) return;
    const selectors = info.querySelector('variant-selects');
    const model = parseJSON(info.querySelector('[data-auzi-variants]'));
    if (!selectors || !Array.isArray(model) || !model.length) return;

    const urlVariant = respectUrl ? new URL(location.href).searchParams.get('variant') : null;
    const selectedNode = selectors.querySelector('[data-selected-variant]');
    const serverSelected = parseJSON(selectedNode);

    let variant =
      (urlVariant && model.find(v => String(v.id) === String(urlVariant))) ||
      (serverSelected && model.find(v => String(v.id) === String(serverSelected.id))) ||
      model[0];

    if (!variant) return;

    const selects = getProductOptionControls(selectors, 'select');
    if (selects.length === variant.options.length) {
      selects.forEach((select,index) => {
        if (Array.from(select.options).some(o => o.value === variant.options[index])) {
          select.value = variant.options[index];
          syncSelectMetadata(select);
          const wrap=select.closest('[data-auzi-visual-wrap]');
          const value=wrap?.querySelector('[data-auzi-visual-value]');
          if(value) value.textContent=select.options[select.selectedIndex]?.textContent?.trim() || select.value;
        }
      });
    }

    if (selectedNode) selectedNode.textContent = JSON.stringify(variant);

    info.querySelectorAll('form [name="id"], .product-variant-id').forEach(input => {
      input.value = variant.id;
      input.disabled = false;
    });

    const priceWrap=info.querySelector('[id^="price-"]');
    const price=priceWrap?.querySelector('.price');
    if(price){
      const onSale=Number(variant.compareAtPrice||0)>Number(variant.price||0);
      price.classList.toggle('price--on-sale',onSale);
      price.classList.toggle('price--sold-out',!variant.available);
      const regular=price.querySelector('.price__regular .price-item--regular');
      const sale=price.querySelector('.price__sale .price-item--sale');
      const compare=price.querySelector('.price__sale s.price-item--regular');
      if(regular) regular.textContent=variant.priceText||'';
      if(sale) sale.textContent=variant.priceText||'';
      if(compare) compare.textContent=onSale?(variant.compareText||''):'';
    }

    if(variant.featuredMediaId){
      const gallery=info.querySelector('media-gallery');
      const mediaId=`${info.dataset.section}-${variant.featuredMediaId}`;
      if(gallery?.setActiveMedia) gallery.setActiveMedia(mediaId,false,true);
      else {
        const media=info.querySelector(`[data-media-id="${mediaId}"]`);
        if(media){
          info.querySelectorAll('[data-media-id]').forEach(el=>el.classList.remove('is-active'));
          media.classList.add('is-active');
        }
      }
    }

    const submit=info.querySelector('.product-form__submit');
    if(submit){
      submit.disabled=!variant.available;
      submit.toggleAttribute('disabled',!variant.available);
    }
  };

  const variantFromCardModel = (model) =>
    model?.variants?.find(v => v.options.every((value,i)=>value===model.selected[i])) || model?.variants?.[0];

  const reconcileCard = (el) => {
    const data=el?.querySelector('[data-card-variants]');
    const model=parseJSON(data);
    if(!model?.variants?.length) return;
    const variant=variantFromCardModel(model);
    const card=el.closest('.product-card-wrapper');
    if(!variant || !card) return;

    const image=card.querySelector('.card__media img');
    if(image && variant.image){
      image.removeAttribute('srcset');
      image.src=variant.image;
      image.alt=variant.alt||'';
      card.classList.add('auzi-variant-preview');
    }

    el.querySelectorAll('[data-option-index]').forEach(group=>{
      const idx=Number(group.dataset.optionIndex);
      const value=variant.options[idx];
      const label=group.querySelector('[data-option-label]');
      if(label) label.textContent=value||'';
      group.querySelectorAll('button[data-value]').forEach(btn=>{
        btn.setAttribute('aria-pressed',String(btn.dataset.value===value));
      });
    });

    const price=card.querySelector('[data-auzi-card-price]');
    if(price){
      const current=price.querySelector('[data-current-price]');
      const compare=price.querySelector('[data-compare-price]');
      if(current) current.innerHTML=variant.priceText||'';
      if(compare){
        const show=Number(variant.compareAt||0)>Number(variant.price||0);
        compare.hidden=!show;
        compare.innerHTML=show?(variant.compareText||''):'';
      }
    }

    const url=new URL(el.dataset.productUrl,location.origin);
    url.searchParams.set('variant',variant.id);
    card.querySelectorAll('.card__heading a').forEach(link=>{link.href=url.href;});
  };

  const reconcileAll = () => {
    document.querySelectorAll('product-info').forEach(info=>reconcileProduct(info));
    document.querySelectorAll('auzi-card-variants').forEach(reconcileCard);
  };

  // Fix Safari/Chrome form-state restoration before Dawn's variant handler runs.
  document.addEventListener('change',(event)=>{
    const select=event.target.closest?.('variant-selects select');
    if(select) syncSelectMetadata(select);
  },true);

  // Re-run after the normal variant code so price/media/URL cannot get stuck.
  document.addEventListener('change',(event)=>{
    const select=event.target.closest?.('variant-selects select');
    if(!select) return;
    const info=select.closest('product-info');
    queueMicrotask(()=>{
      const selectors=info?.querySelector('variant-selects');
      const model=parseJSON(info?.querySelector('[data-auzi-variants]'));
      if(!selectors || !Array.isArray(model)) return;
      const values=getProductOptionControls(selectors, 'select').map(s=>s.value);
      const variant=model.find(v=>v.options.length===values.length && v.options.every((x,i)=>x===values[i]));
      if(!variant) return;
      const selectedNode=selectors.querySelector('[data-selected-variant]');
      if(selectedNode) selectedNode.textContent=JSON.stringify(variant);
      const u=new URL(location.href);
      u.searchParams.set('variant',variant.id);
      history.replaceState({},'',u);
      reconcileProduct(info,{respectUrl:true});
    });
  });

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',reconcileAll,{once:true});
  else reconcileAll();

  window.addEventListener('pageshow',()=>requestAnimationFrame(reconcileAll));
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(reconcileAll));
})();

